import React, { FC } from 'react';
import { LandscapeAboutNotSavedInfoTemplate } from '../../templates';

interface LandscapeAboutNotSavedInfoPageProps {
  content: string;
}

const LandscapeAboutNotSavedInfoPage: FC<
  LandscapeAboutNotSavedInfoPageProps
> = ({ content }) => {
  return <LandscapeAboutNotSavedInfoTemplate content={content} />;
};

export default LandscapeAboutNotSavedInfoPage;
